<template>
  <div class="text-center">
      
      <v-card>
        <v-card-title class="text-h5 indigo white--text">
          Ingrese Rango de Fechas
        </v-card-title>

        <v-card-text>
         <v-row>
              <v-col cols="12">
                 <!-- SeleccionarEstablecimiento -->
                 <v-autocomplete v-model="fechas.idestablecimiento" :items="getEstablecimientosActivas" hide-details
                      item-text="nombrecomercial" item-value="idestablecimiento" outlined dense
                      label="Seleccione Establecimiento / Bodega"></v-autocomplete>
              </v-col>
             <v-col cols="6">
                 <v-text-field
                 type="date"
                v-model="fechas.fechainicio"
                label="Fecha Inicio"
                @change="validarFechas(fechas)"
              ></v-text-field>
             </v-col>
             <v-col cols="6">
                 <v-text-field
                  type="date"
                  v-model="fechas.fechafin"
                  label="Fecha Fin"
                  @change="validarFechas(fechas)"
                ></v-text-field>
             </v-col>
         </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="indigo"
            @click="$emit('ventasporfecha',fechas)" 
            dark
          >
            Filtrar
          </v-btn>
        </v-card-actions>
      </v-card>

  </div>
</template>
<script>
//import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
export default {
  props: ["fechas"],
  data:()=>({
    formvalid:false,
  }),
  computed:{
    ...mapGetters(["getEstablecimientosActivas"])
  },
  methods:{
    validarFechas(fechas) {
        fechas.fechainicio = dayjs(fechas.fechainicio).format('YYYY-MM-DD') //.startOf('day')
        fechas.fechafin = dayjs(fechas.fechafin).format('YYYY-MM-DD') //.startOf('day')

        if (fechas.fechainicio > fechas.fechafin) {

          fechas.fechafin = dayjs(fechas.fechainicio).format('YYYY-MM-DD')
          this.formvalid = true

        }
      },
  }
}
</script>